<div class="edit-page-root-container tag-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
            </div>
        </div>
        <div class="page-details ">
            <div class="detail-section">
                <form class="edit-form" [formGroup]="editForm">
                    <div class="content-container">
                        <mat-form-field class="code">
                            <mat-label>Code</mat-label>
                            <input matInput formControlName="code" maxlength="50"
                                [readonly]="tagInfo.id!==undefined && tagInfo.id!==0">
                            <mat-error *ngIf="editForm.controls['code'].hasError('required')">Tag code should be entered</mat-error>
                            <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is 50.</mat-error>
                        </mat-form-field>
                        <mat-form-field class="name">
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name">
                            <mat-error *ngIf="editForm.controls['name'].hasError('required')">Tag name should be entered</mat-error>
                            <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is 50.</mat-error>
                        </mat-form-field>
                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                            <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length is 200.</mat-error>
                        </mat-form-field>
                        <div class="color-container">
                            <mat-form-field class="color-chooser fg-color">
                                <mat-label>Text color</mat-label>
                                <input matInput formControlName="fg_color" type="color">
                                <mat-error *ngIf="editForm.controls['fg_color'].hasError('maxlength')">Maximum length is 50.</mat-error>
                            </mat-form-field>
                            <mat-form-field class="color-chooser bg-color">
                                <mat-label>Background</mat-label>
                                <input matInput formControlName="bg_color" type="color">
                                <mat-error *ngIf="editForm.controls['bg_color'].hasError('maxlength')">Maximum length is 50.</mat-error>
                            </mat-form-field>
                            <div class="preview-container">
                                <div class="preview" [style.background]="editForm.controls['bg_color'].value"
                                    [style.color]="editForm.controls['fg_color'].value">
                                    {{editForm.controls['name'].value }}
                                </div>
                            </div>
                        </div>
                        <div class="status-toggle-container">
                            <span class="status-toggle-title">Active</span>
                            <mat-slide-toggle formControlName="is_valid" class="status-toggle"></mat-slide-toggle>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>